export function stepTrace(trace, stepName) {
  const steps = trace?.steps;
  if (!Array.isArray(steps)) return null;
  return steps.find((s) => s?.step === stepName) || null;
}

export function buildAiCopyBundle(layout, brief) {
  const ai = layout?.ai;
  const trace = ai?.trace;
  const intentStep = stepTrace(trace, 'intent') || (trace?.step === 'intent' ? trace : null);
  const htmlStep = stepTrace(trace, 'layout_html');
  return {
    exported_at: new Date().toISOString(),
    brief: brief || layout?.brief || '',
    media_creator: ai
      ? {
          prompt_version: ai.prompt_version,
          model: ai.model,
          compiler: ai.compiler,
          generated_at: ai.generated_at,
          response_format: intentStep?.response_format || trace?.response_format,
          trace: trace || null,
        }
      : null,
    layout_meta: layout?.meta || null,
    normalized_intent: intentStep?.normalized_intent || trace?.normalized_intent || null,
    model_response: intentStep?.model_response || trace?.model_response || null,
    layout_html_response: htmlStep?.model_response || null,
    system_prompt: intentStep?.system_prompt || trace?.system_prompt || null,
    layout_html_system_prompt: htmlStep?.system_prompt || null,
    user_payload: intentStep?.user_payload || trace?.user_payload || null,
    schema: intentStep?.schema || trace?.schema || null,
    html_fallback_reason: trace?.html_fallback_reason || null,
    html_fallback_trace: trace?.html_fallback_trace || null,
    html_salvaged: trace?.html_salvaged ?? null,
    html_salvage_error: trace?.html_salvage_error || null,
    failed_step: trace?.failed_step || null,
    notes: trace?.note || trace?.html_fallback_reason || trace?.error || null,
  };
}

export function formatAiCopyBundle(bundle) {
  return JSON.stringify(bundle, null, 2);
}
